

import state from './moduleRoleState.js'
import mutations from './moduleRoleMutations.js'
import actions from './moduleRoleActions.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
